import React from 'react';
import debounce from 'lodash/debounce';
import { Spin, Select } from 'antd';

const Option = Select.Option;
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'cs-select-mul',
    rowKey: 'key',
    nameKey: 'name',
  }
  constructor(props) {
    super(props);
    this.state = {
      datas: props.datas || [],
      initDatas: props.datas || [],
      value: '',
      visible: false,
      selectedKeys: [], // 内部选中数据
      selectedValues: [], // 外部受控数据
      loading: false,
    }
  }

  componentDidMount() {
    this.fetchData();
  }
  
  componentWillReceiveProps(nextProps) {
    this.fetchData();
    const { value: _value, rowKey, nameKey } = this.props;
    const { value } = nextProps;
    if (value !== _value && value) {
      const values = value.split(',');
      const res = [];
      this.fetchData(() => {
        const { datas } = this.state;
        values.forEach((v) => {
          const re = datas.find((da) => da[rowKey] === v);
          if (re) {
            res.push({
              [`${rowKey}`]: re[rowKey],
              [`${nameKey}`]: re[nameKey],
            });
          }
        })
        this.setState({ selectedKeys: values, selectedValues: res });
      })
    }
  }

  onSelectChange = (value) => {
    const { onChange, rowKey, nameKey, isSingle } = this.props;
    if (!value || value.length === 0) {
      this.setState({ selectedValues: [], selectedKeys: [] }, () => {
        if (typeof onChange === 'function') onChange('', '', value);
      });
      return;
    }
    if (isSingle === 'true' || isSingle === true) {
      const ids = [], names = [];
      const len = value.length - 1;
      ids.push(value[len][rowKey]);
      names.push(value[len][nameKey]);
      this.setState({ selectedValues: [value[len]], selectedKeys: ids }, () => {
        if (typeof onChange === 'function') onChange(ids.join(), names.join(), value);
      });
    } else {
      const ids = value.map((val) => val[rowKey]);
      const names = value.map((val) => val[nameKey]);
      this.setState({ selectedValues: value, selectedKeys: ids }, () => {
        if (typeof onChange === 'function') onChange(ids.join(), names.join(), value);
      });
    }
  }

  fetchData = (cb) => {
    const { fetchData } = this.props;
    if (typeof fetchData === 'function') {
      this.setState({ loading: true });
      fetchData().then((data) => {
        this.setState({ datas: data, initDatas: data, loading: false }, () => {
          typeof cb === 'function' && cb();
        });
      })
    }
  }

  filterData = (val) => {
    const { nameKey } = this.props;
    const { initDatas } = this.state;
    const filterDatas = initDatas.filter((data) => data[nameKey].indexOf(val) >= 0);
    this.setState({ datas: filterDatas });
  }

  render() {
    const { prefixCls, label: title, rowKey, nameKey } = this.props;
    const { datas, loading, selectedValues } = this.state;
    return (
      <div className={prefixCls}>
        <Select
          className={`${prefixCls}-searchSelect`}
          mode="multiple"
          loading={loading}
          labelInValue
          value={selectedValues}
          placeholder={`请输入${title}`}
          notFoundContent={loading ? <Spin size="small" /> : '暂无数据'}
          filterOption={false}
          onSearch={debounce(this.filterData, 400)}
          onChange={this.onSelectChange}
        >
          {
            datas && datas.length > 0 && datas.map((data) => (
              <Option key={data[rowKey]}>
                {data[nameKey]}
              </Option>
            ))
          }
        </Select>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/public/cs-select-mul/index.js